import * as resourceService from './resource';

export function getMenu() {
    const hotelItem = {
        Text: resourceService.get('MENUHOTELS'),
        Url: '/hotels',
        PrimaryItem: true
    };
    const transferItem = {
        Text: resourceService.get('MENUTRANSFERS'),
        Url: 'transfers',
        PrimaryItem: true
    };
    const marhabaItem = {
        Text: resourceService.get('MENUMARHABA'),
        Url: '/marhaba',
        PrimaryItem: true
    };
    const holidayItem = {
        Text: resourceService.get('MENUHOLIDAYS'),
        Url: '/holidays',
        PrimaryItem: true
    };
    const flightItem = {
        Text: resourceService.get('MENUFLIGHTS'),
        Url: '/flights',
        PrimaryItem: true
    };
    const dealItem = {
        Text: resourceService.get('MENUDEALS'),
        Url: 'deals',
        PrimaryItem: true
    };
    const insuranceItem = {
        Text: resourceService.get('MENUINSURANCE'),
        Url: '/insurance',
        PrimaryItem: true
    };
    const cruiseItemForNewWindow = {
        Text: resourceService.get('MENUCRUISE'),
        Url: TRPCONFIG.Domain.CruiseRootUrl,
        PrimaryItem: true,
        NewWindow: true
    };
    const carhireItem = {
        Text: resourceService.get('MENUCARHIRE'),
        Url: 'http://www.hertz-gsa.ae/',
        PrimaryItem: true
    };
    const dailysalesreportItem = {
        Text: resourceService.get('DAILYSALESREPORT'),
        Url: '/Reports/conDailySalesReport.aspx',
        PrimaryItem: true
    };
    const faqItem = {
        Text: resourceService.get('MENUFAQ'),
        Url: '/faq/faqhome.aspx',
        PrimaryItem: true
    };
    const contactusItem = {
        Text: resourceService.get('MENUCONTACTUS'),
        Url: '/help/contact-us.aspx',
        PrimaryItem: true
    };

    const menus = {
        1: {
            Items: [
                hotelItem,
                holidayItem,
                flightItem,
                dealItem,
                {
                    Text: resourceService.get('MENUALLINCLUSIVE'),
                    Url: '/all-inclusive',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUTRANSFERS'),
                    Url: 'transfers',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUCARHIRE'),
                    Url: '/car-hire',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUPARKING'),
                    Url: 'parking',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUATTRACTIONS'),
                    Url: '/attractions',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUCRUISE'),
                    Url: 'https://cruise.travelrepublic.co.uk/',
                    PrimaryItem: false
                }
            ]
        },
        2: {
            Items: [
                hotelItem,
                holidayItem,
                flightItem,
                dealItem,
                {
                    Text: resourceService.get('MENUALLINCLUSIVE'),
                    Url: '/all-inclusive',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUTRANSFERS'),
                    Url: 'transfers',
                    PrimaryItem: false
                },
                {
                    Text: resourceService.get('MENUATTRACTIONS'),
                    Url: '/attractions',
                    PrimaryItem: false
                }
            ]
        },
        11: {
            Items: [
                {
                    Text: resourceService.get('MENUABOUTUS'),
                    Url: '/help/acerca-de-travel-republic.aspx',
                    PrimaryItem: true
                },
                {
                    Text: resourceService.get('MENUPRICEPROMISE'),
                    Url: '/help/pricepromise.aspx',
                    PrimaryItem: true
                },
                {
                    Text: resourceService.get('MENUCUSTOMERINFORMATION'),
                    Url: '/importantinfo.aspx',
                    PrimaryItem: true
                }
            ]
        },
        16: {
            Items: [
                {
                    Text: resourceService.get('MENUABOUTUS'),
                    Url: '/help/chi-siamo.aspx',
                    PrimaryItem: true
                },
                {
                    Text: resourceService.get('MENUPRICEPROMISE'),
                    Url: '/help/pricepromise.aspx',
                    PrimaryItem: true
                },
                {
                    Text: resourceService.get('MENUCUSTOMERINFORMATION'),
                    Url: '/importantinfo.aspx',
                    PrimaryItem: true
                }
            ]
        },
        34: {
            Items: [
                hotelItem,
                flightItem,
                holidayItem,
                transferItem,
                cruiseItemForNewWindow,
                insuranceItem,
                marhabaItem
            ]
        },
        35: {
            Items: [
                hotelItem,
                flightItem,
                holidayItem,
                transferItem,
                marhabaItem
            ]
        },
        36: {
            Items: [
                hotelItem,
                transferItem,
                marhabaItem,
                flightItem,
                holidayItem
            ]
        },
        37: {
            Items: [
                hotelItem,
                transferItem,
                marhabaItem,
                flightItem,
                holidayItem
            ]
        },
        66: {
            Items: [
                hotelItem,
                transferItem,
                marhabaItem,
                flightItem,
                holidayItem
            ]
        },
        55: {
            Items: [
                hotelItem,
                flightItem,
                holidayItem,
                transferItem,
                insuranceItem,
                marhabaItem
            ]
        }

    };

    //handling dnata-domains
    [31, 32, 33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 106].forEach(function(domain) {
        menus[domain] = {
            Items: TRPCONFIG.Domain.isAgentMode ? [
                dailysalesreportItem,
                contactusItem,
                faqItem
            ] : []
        };
    });

    [62, 63, 64, 65].forEach(function(domain) {
        menus[domain] = {
            Items: TRPCONFIG.Domain.isAgentMode ? [
                dailysalesreportItem,
                contactusItem,
                faqItem,
                carhireItem
            ] : []
        };
    });

    [30, 38, 39, 40, 41].forEach(function(domain) {
        menus[domain] = {
            Items: TRPCONFIG.Domain.isAgentMode ? [
                dailysalesreportItem,
                contactusItem,
                faqItem,
                insuranceItem,
                carhireItem
            ] : []
        };
    });

    // mock http call with promise
    return Promise.resolve(menus[TRPCONFIG.Domain.DomainId]);
}
